<template>
	<div v-if="isload" class="createorder_export1">
		<el-row style="margin-bottom:45px;">
			<el-col :span="24"><stockmain ref="stockmain" @setselectrow="setselectrow" :l_mode="'主单信息-'+t_type" @setvalue="setvalue"></stockmain></el-col>
			<el-col :span="24">
				<packagecargo ref="packagecargo" :gridheight="gridheight" title="商品明细" :l_mode="'商品明细列表-'+t_type" :isselcargo="isselcargo" @setvalue="setvalue" @formScrollTop="formScrollTop" @addedcallback="addedcallback"></packagecargo>
			</el-col>
		</el-row>
		<el-row v-if="!btnhidden&&isdetail==0" class="footerhandler">
			<el-col :span="4" style="text-align: right;">
				<span style="color:transparent">1</span>
			</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveorder">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">取消</div></el-col>
		</el-row>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="650px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">下单成功</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4"><span style="color:transparent">1</span></el-col>
				<el-col :span="6"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="4"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="4" style="text-align: right;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import stockmain from '@/components/stockmanager/stockmain.vue';
import packagecargo from '@/components/order/import_package_cargo1.vue';
export default {
	components: {
		stockmain,
		packagecargo
	},
	props: {},
	data() {
		return {
			syscol: '',
			gridheight: '350px',
			orderinfo: {},
			billid:'',
			// pkval:'',
			iscopy: 0,
			btnhidden: false,
			sendremind: false,
			isload: false,
			checkedpmode: '',
			t_id: '',
			showsuccesswin: false,
			wintips: false,
			divclass:'createorder_export1',
			t_type:'',
			isselcargo:false,
			handletype:'',
			planbillid:'',
			plancargolist:[],
			orderstate:1,
			isdetail:0
		};
	},
	methods: {
		init(param) {
			//debugger
			var that = this;
			this.isload = false;
			this.planbillid='';
			this.orderstate=1;
			this.isdetail=0;
			if(param.isdetail!=undefined)
				this.isdetail=param.isdetail;
			if (param.checkedpmode != undefined) this.checkedpmode = param.checkedpmode;
			if (param.syscol != undefined) this.syscol = param.syscol;
			if (param.orderinfo != undefined){
				if(param.orderinfo.stockmain!=undefined){
					if(param.orderinfo.stockmain.sendtype!=undefined)
					{
						if(param.orderinfo.stockmain.sendtype!=''){
							this.planbillid=param.orderinfo.stockmain.sendtype;
							this.plancargolist=JSON.parse(JSON.stringify(param.orderinfo.list[0].cargolist));
						}
					}
				}
				this.orderinfo =param.orderinfo;
			}
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.t_id != undefined) this.t_id = param.t_id;
			if(param.t_type!=undefined) this.t_type = param.t_type;
			if(param.handletype!=undefined) this.handletype=param.handletype;
			if(param.isselcargo!=undefined) this.isselcargo = param.isselcargo;
			if (this.syscol != '') {
				this.isload = true;
				this.$nextTick(function() {
					that.$refs.stockmain.init({ syscol: that.syscol, orderinfo: that.orderinfo,t_type:that.t_type,isdetail:that.isdetail});
					that.$refs.packagecargo.init({ syscol: that.syscol, orderinfo: that.orderinfo, iscopy: that.iscopy,t_type:that.t_type,isdetail:that.isdetail });
				});
			}
		},
		//获取订单信息
		getorderObj() {
			//debugger
			var that = this;
			var error = '';
			var stockmain = '',
				receiver = '',
				orderlist = [];
			var orderinfo = {};
			var setlist = this.$refs.stockmain._data.setlist;
			if (setlist.length > 0) {
				setlist.forEach(e => {
					if (e.value == undefined) {
						e.value = '';
					}
					if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
						error = '请填写' + that.$refs.stockmain.title + '-' + e.showname;
						stockmain = '';
					} 
					if (error == '') stockmain += '"' + e.colname + '":"' + e.value + '",';
					else return false;
				});
				if (error == '') {
					if (stockmain != '') {
						stockmain = stockmain.replace(/\n/g, '');
						stockmain = '{' + stockmain.substring(0, stockmain.length - 1) + '}';
						orderinfo.stockmain = JSON.parse(stockmain);
					}
				}
			}
			if (error == '') {
				var pageset = this.$refs.packagecargo._data.pageset;
				var cargorow = this.$refs.packagecargo._data.columns;
				var index = 0;
				var list = [],
					cargolist = [];
				var baginfo = '';
				pageset.forEach(e => {
					index++;
					baginfo = '';
					cargolist = [];
					e.setlist.forEach(b => {
						if (b.value == undefined) {
							b.value = '';
						}
						if (b.controltype == 'combox-input' && b.ishidden == 'False') {
							var volume = b.combox;
							for (var k = 0; k < volume.length; k++) {
								if (volume[k].value == undefined) {
									volume[k].value = '';
								}
								if (volume[k].isnull == 'False' && volume[k].value == '') {
									error = '请填写' + volume[k].showname;
									break;
								}
								baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
							}
						} else if (b.controltype == 'table' && b.ishidden == 'False') {
							if (b.isnull == 'False') {
								if (b.cargolist.length > 0) {
									var cargoindex = 0;
									b.cargolist.forEach(cargo => {
										cargoindex++;
										for (var col in cargo) {
											cargorow.forEach(c => {
												if (col == c.field) {
													if (c.isnull == 'False' && c.colshow == '1') {
														if (cargo[col] == '') error = '【第' + cargoindex + '行】' + c.title + '为空';
													}
													return false;
												}
												if (error != '') return false;
											});
											if (error != '') return false;
										}
										if (error != '') return false;
									});
								} else error = '请填写' + b.showname;
							}
							if (error == '') cargolist = b.cargolist;
						} else if (b.ishidden == 'False') {
							if (b.isnull == 'False' && b.value == '') error = '请填写' + b.showname;
							else baginfo += '"' + b.colname + '":"' + b.value + '",';
						}
					});
					if (error != '') {
						list = [];
						return false;
					} else {
						if (baginfo != '') {
							baginfo = baginfo.replace(/\n/g, '');
							baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
						} else {
							baginfo = '{}';
						}
						list.push({ idx: index, baginfo: JSON.parse(baginfo), cargolist: JSON.parse(JSON.stringify(cargolist)) });
					}
				});
				orderinfo.list = list;
			}
			if (error != '') {
				this.$tool.message(error, 0);
				orderinfo = '';
				return false;
			}
			return orderinfo;
		},
		//保存入库单计划单/入库单
		saveorder() {
			var that = this;
			//debugger
			var orderinfo = this.getorderObj();
			if (orderinfo != '') {
				var checkinfo=this.CheckPlan(orderinfo);
				orderinfo.sendaddress=checkinfo.state;//订单状态
				this.orderstate=checkinfo.state;
				if(checkinfo.state==1)
					this.saveorder2(orderinfo);
				else{
					this.$confirm(checkinfo.message, '提示', {
						cancelButtonText: '否',
						confirmButtonText: '是',
						type: 'warning',
						showClose: false,
						closeOnClickModal: false
					})
					.then(res => {
						 this.saveorder2(orderinfo);
					});
				}
			}
		},
		saveorder2(orderinfo){
			var that=this;
			if(orderinfo.sendaddress==2&&orderinfo.stockmain.p_pkval==this.planbillid){//部分入库,并且订单号不等于计划单号，则生成新单号
					orderinfo.stockmain.p_pkval=new Date().getTime();
			}
			orderinfo.u_userid = localStorage.getItem('userid');
			orderinfo.p_mode = this.checkedpmode;
			orderinfo.t_id = this.t_id;
			orderinfo.editid=this.$parent.$parent.billid;
			this.btnhidden=true;
			this.$tool.loading('正在保存', this.$parent.divclass);
			this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
				if (res.state == '1') {
					//debugger
					if(that.handletype=='instock'||that.handletype=='outstock'){
						that.billid = res.pkval;
						that.UpdateStock();
					}
					else{
						that.btnhidden=false;
						this.$tool.loadingclose();
						that.billid = res.pkval;
						that.showsuccesswin=true;
					}
					
				} else{
					that.btnhidden=false;
					this.$tool.loadingclose();
					if(res.localfilename!=undefined){
						if(res.localfilename!=""){
							this.$tool.downfile(that,res.localfilename);
						}
					}
					that.$tool.message(res.message, 0);
				} 
			}).catch(e=>{
				that.btnhidden=false;
				this.$tool.loadingclose();
				that.$tool.message('网络异常，请重试', 0);
			});
		},
		cancel() {
			this.$emit('cancel');
		},
		formScrollTop() {
			this.$emit('formScrollTop');
		},
		successfun(type) {
			var that = this;
			this.orderstate=1;
			this.btnhidden=false;
			that.showsuccesswin = false;
			if (type == 0) {
				//关闭
				this.cancel();
			} else if (type == 1) {
				//复制新增
				this.billid='';
				this.$refs.stockmain.resetBillid();
				
			} else if (type == 2) {
				this.billid='';
				this.$parent.$parent.billid='';
				//新增订单，清空界面上所有填写的
				this.init({});
			}
		},
		setvalue(e){
			//debugger
			// if(this.$refs.stockmain._data[e.data]!=undefined)
			// 	this.$refs.stockmain.setvalue(e.data,e.value);
			if(this.$refs.packagecargo._data[e.data]!=undefined)
				this.$refs.packagecargo.setvalue(e.data,e.value);
		},
		setselectrow(e){
			//debugger
			this.$parent.$parent.init({pkval:'',type:e.type,iscopy:0,handletype:this.handletype,planbillid:e.billid});
		},
		//更新库存
		UpdateStock(){
			var that=this;
			var isadd=true;
			if(this.$parent.$parent.billid!=undefined&&this.$parent.$parent.billid!='')
				isadd=false;
			var paraminfo={
				billid:this.billid,
				storagehouse:this.$refs.packagecargo._data.storagehouse,
				handletype:this.handletype,
				handleraccount: localStorage.getItem('u_account')
			}
			this.$apipost.post.UpdateStock({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					that.DelPlan();
				} else{
					if(isadd){
						that.RollBackStockBill(res.message);
					}
					else
					{
						that.btnhidden=false;
						that.$tool.message(res.message, 0);
					}
				}
			});
		},
		//删除计划单
		DelPlan(){
			var that=this;
			if(this.planbillid!='')
			{
				if(this.handletype=='instock'){
					var paraminfo={
						planbillid:this.planbillid,
						billid:this.billid,
						orderstate:this.orderstate
					}
					this.$apipost.post.DelStockInPlan({ paraminfo: paraminfo }).then(res => {
						this.$tool.loadingclose();
						if (res.state == '1') {
							that.planbillid='';
							that.showsuccesswin=true;
						} else{
							that.btnhidden=false;
							that.$tool.message(res.message, 0);
						} 
					});
				}
			}
			else
				this.showsuccesswin=true;
		},
		//判断是否有计划单号录入
		CheckPlan(orderinfo){
			var checkresult={state:1,message:''};
			var that=this,fun='入库',isgo=true,cargolist=JSON.parse(JSON.stringify(orderinfo.list[0].cargolist));
			
			if(that.handletype=='outstock')
				fun='出库';
			var plancargolist=[];
			this.plancargolist.forEach(e=>{
				cargolist.forEach(b=>{
					if(e.cno==b.cno)
						plancargolist.push(e);
				});
			});
			if(plancargolist.length>0&&cargolist.length>0){
				plancargolist.forEach(e=>{
					var existslist=cargolist.filter(function(b) {
						return b.cno==e.cno;
					});
					if(existslist.length>0){
						if(parseInt(existslist[0].num)<parseInt(e.num)){
							checkresult.state=2;
							checkresult.message='录入的商品【'+existslist[0].cno+'】数量少于计划单商品数量，是否部分'+fun+'？';
						}
						if(checkresult.state==1){
							if(parseInt(existslist[0].num)>parseInt(e.num)){
								checkresult.state=3;
								checkresult.message='录入的商品【'+existslist[0].cno+'】数量与计划单商品不一致，是否按当前商品信息'+fun+'？';
							}
						}
					}
				});
			}
			return checkresult;
		},
		RollBackStockBill(message){
			var that=this;
			var paraminfo={
				billid:this.billid,
				handletype:this.handletype,
				handleraccount: localStorage.getItem('u_account')
			}
			this.$tool.loading('保存失败，正在回滚', this.$parent.divclass);
			this.$apipost.post.RollBackStockBill({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				that.btnhidden=false;
				if (res.state == '1') {
					that.$tool.message(message, 0);
				} else{
					that.$tool.message('保存失败', 0);
				} 
			});
		},
		addedcallback(e){
			if(e.gridrowindex>-1){
				var that=this;
				var pageset = this.$refs.packagecargo._data.pageset;
				var cargorow = this.$refs.packagecargo._data.columns;
				cargorow.forEach(b=>{
					if(b.validate!=undefined){
						if(b.validate!=''&&b.validate.split('|').length>0){
							if(b.validate.split('|')[0]=='getshelves'){//表示要获取货架
								if(pageset.length>0){
									if(pageset[0].setlist[0].cargolist.length>0){
										that.getshelves(b,e.gridrowindex,pageset[0].setlist[0].cargolist);
									}
								}
							}
						}
					}
				});
			}
		},
		getshelves(b,index,cargolist){
			if(index<cargolist.length){
				var that=this;
				var col=b.validate.split('|')[1].split(',')[0];//条件字段
				var valuecol=b.validate.split('|')[1].split(',')[1];//结果赋值字段
			
				var paraminfo={};
				paraminfo[col]=cargolist[index][col];
				paraminfo.storehouse=this.$refs.packagecargo._data.storagehouse;
				
				this.$apipost.get.GetCargoshelves({ paraminfo: paraminfo }).then(res => {
					var list=[];
					if (res.state == '1') 
						list=res.list;
					if(list.length>0)
						cargolist[index][valuecol]=list[0].value;
					that.getshelves(b,(parseInt(index)+1),cargolist);
				});
			}
		}
	}
};
</script>

<style></style>
